export enum PasswordInputType {
    Text = "text",
    Password = "password",
}